import React from 'react'

export const PaginationNext = ({ children, disabled = false, action = () => {} }) => {
  return (
    <button
      onClick={(e) => {
        action()
      }}
      className={`pagination-next ${disabled && 'is-disabled'}`}
      type="button"
    >
      {children}
    </button>
  )
}
